import _ from 'lodash';
import { createActionHelpers } from 'vuex-loading';

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const UPDATE_TABLE_CTX = 'UPDATE_TABLE_CTX';
export const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA';
export const ADD_FILTER_TO_MODEL = 'ADD_FILTER_TO_MODEL';
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_SEARCHED_CLIENTS = 'UPDATE_SEARCHED_CLIENTS';
export const UPDATE_FIND_RESULT = 'UPDATE_FIND_RESULT';

export const submitSearchFichasComercialesAction = 'submitSearchFichasComercialesAction';
export const resetSearchedFichasComercialesAction = 'resetSearchedFichasComercialesAction';
export const setFilterAction = 'setFilterAction';
export const changeErrorStatus = 'changeErrorStatus';
export const createClientAction = 'createClientAction';
export const searchByFilterAction = 'searchByFilterAction';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});


async function fichaComercialOperation(ops, fichas) {
  _.forOwn(ops, (op) => {
    if (op && op.fichaComercial) {
      if (fichas && fichas.length > 0) {
        fichas.forEach((ficha) => {
          if (op.fichaComercial === ficha.id) {
            ficha.operation = op.id;
          }
        });
      }
    }
  });
  return fichas;
}

const initState = {
  error: '',
  loading: false,
  searchedResults: [],
  formModel: {
    filtro: '',
  },
  findResult: false,
  tableCtx: {
    currentPage: 1,
    perPage: 10,
    filter: '',
    sortBy: '',
    sortDesc: false,
  },
  tableData: [],
};

export default {
  namespaced: true,
  state: Object.assign({}, initState),
  mutations: {
    [CLEAR_MODULE](state) {
      Object.assign(state, initState);
    },
    [UPDATE_LOADING](state, loading) {
      state.loading = loading;
    },
    [UPDATE_ERROR](state, msg) {
      state.error = msg;
    },
    [UPDATE_TABLE_CTX](state, model) {
      state.tableCtx = Object.assign({}, state.tableCtx, model);
    },
    [ADD_FILTER_TO_MODEL](state, filter) {
      state.formModel.filtro = filter;
    },
    [UPDATE_TABLE_DATA](state, lista) {
      state.tableData = lista;
    },
    [UPDATE_SEARCHED_CLIENTS](state, lista) {
      state.searchedClients = lista;
    },
    [UPDATE_FIND_RESULT](state, payload) {
      state.findResult = payload;
    },
    [UPDATE_FORM_DATA](state, payload) {
      payload.filtro = state.formModel.filtro;
      state.formModel = payload;
    },
  },
  actions: {
    [submitSearchFichasComercialesAction]({ commit, dispatch, rootGetters }, payload) {
      startLoading(dispatch, 'buscar fichaComercial');
      commit(UPDATE_LOADING, true);
      commit(UPDATE_ERROR, '');
      commit(UPDATE_FORM_DATA, payload);
      const operations = rootGetters['operation_model/entitiesGetter'];
      const fetchConfig = {};
      _.forOwn(payload, (value, key) => {
        if (value && value !== '') {
          if (key === 'nombre') {
            fetchConfig.nombreFilter = {
              modelName: 'investmentForm',
              operator: 'CONTAINS',
              value,
              path: 'investment_form',
            };
          } else if (key === 'finalidad') {
            fetchConfig.apellidosFilter = {
              modelName: 'propertyState',
              operator: 'CONTAINS',
              value,
              path: 'property_state',
            };
          }
        }
      });
      return dispatch('businessCard_model/fetchAction', fetchConfig, { root: true })
        .then((results) => {
          fichaComercialOperation(operations, results.entities)
            .then((res) => {
              if (res.length <= 0) {
                commit(UPDATE_TABLE_DATA, []);
              } else {
                commit(UPDATE_TABLE_DATA, res);
              }
              commit(UPDATE_LOADING, false);
              commit(UPDATE_FIND_RESULT, true);
              endLoading(dispatch, 'buscar fichaComercial');
            });
        })
        .catch((error) => {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'buscar fichaComercial');
        });
    },
    [changeErrorStatus]({ commit }, msg) {
      commit(UPDATE_ERROR, msg);
    },
    [resetSearchedFichasComercialesAction]({ commit }) {
      commit(CLEAR_MODULE);
    },
    [searchByFilterAction]({ commit, dispatch, rootGetters }, filter) {
      startLoading(dispatch, 'buscar fichaComercial');
      commit(UPDATE_LOADING, true);
      commit(UPDATE_ERROR, '');
      const operations = rootGetters['operation_model/entitiesGetter'];
      let config = {};
      switch (filter) {
        case 'Ver todas':
          config = {};
          break;
        case 'Visibles en App':
          config = {
            viewVisibles: {
              modelName: 'publicada',
              operator: '=',
              value: 1,
              path: 'publicada',
            },
          };
          break;
        case 'No visibles en App':
          config = {
            viewNoVisibles: {
              modelName: 'publicada',
              operator: '=',
              value: 0,
              path: 'publicada',
            },
          };
          break;
        default:
          break;
      }
      dispatch('businessCard_model/fetchAction', config, { root: true }).then((result) => {
        const { entities } = result;
        fichaComercialOperation(operations, entities)
          .then((res) => {
            if (Array.isArray(res) && res.length > 0) {
              commit(UPDATE_TABLE_DATA, res);
              commit(UPDATE_LOADING, false);
            } else {
              commit(UPDATE_TABLE_DATA, []);
            }
          });
        commit(UPDATE_LOADING, false);
        commit(UPDATE_FIND_RESULT, true);
        endLoading(dispatch, 'buscar fichaComercial');
      })
        .catch((error) => {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'buscar fichaComercial');
        });
    },
  },
  getters: {
    isLoading: state => state.loading,
    error: state => state.error,
    existError: state => state.error !== '',
    searchedResults: state => state.tableData,
    findResult: state => state.findResult,
  },
};



// WEBPACK FOOTER //
// ./src/features/menu-ficha-comercial/store.js